export default "__VITE_ASSET__Bi$Val0B__"